module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainMap"
  }, [_c('div', {
    staticClass: "maskTitle"
  }, [_c('span', [_vm._v("地点")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "container"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164522b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/components/map.vue
// module id = OlC0
// module chunks = 6